import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@4.4.2_3422d6a04055dad23f81af55cef51739/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}